import React from 'react';
import { Route } from 'react-router-dom';

import Menu from './Menu';
import Main from './Main';
import Promotions from './Promotions';
import Coupons from './Coupons';
import Charges from './Charges';
import Transfers from './Transfers';
import Payouts from './Payouts';
import Users from './Users';
import Businesses from './Businesses';


class Dashboard extends React.Component {

  state = { };
  
  componentDidMount() {
    
  }

  render()  {
    const { match } = this.props;

    console.log(match.url)
    return (  
      <div className='fluid-container'>
        <div className='row'>
          <div className='aside col-md-3 col-lg-2 sidebarMenu'>
            <Menu />
          </div>
          <div className='main col-md-9 col-lg-10'>       
            <div className='fluid-container'>
              <Route exact path='/' component={Main} />
              <Route path='/promotions' component={Promotions} />
              <Route path='/users' component={Users} />
              <Route path='/businesses' component={Businesses} />
              <Route path='/coupons' component={Coupons} />
              <Route path='/charges' component={Charges} />
              <Route path='/transfers' component={Transfers} />
              <Route path='/payouts' component={Payouts} />
            </div>
          </div> 
        </div> 
      </div>    
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/containers/Dashboard.js